module.exports = __webpack_public_path__ + "static/assets/2a417d1567f8b8069c1a5c483339c3e2.svg";